import React from 'react';
import { Label } from 'fw/components';
import { Col, Modal, Row, Button } from 'react-bootstrap';
import { TextAreaBox } from 'fw/forms';

class AppealRequestPopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            visible: props.visible,
			certificationId: props.certificationId,
            appealReason: "",
        }
    }

    componentWillReceiveProps(nextProps) {
        var state = this.state;

        state.visible = nextProps.visible;
        this.setState(state);
    }

    close = () => {
        this.setState({
            visible: false,
			appealReason: "",
        }, function () {
            this.props.onClose();
        });
    }

    confirm = () => {
		var rsp = this.state;

        this.setState({
            visible: false,
			appealReason: "",
        }, function () {
            this.props.onConfirm(rsp);
        });
    }

	onReasonChange = (value) => {
		this.setState({
			appealReason: value,
		})
	}

    render() {
        return (
            <Modal show={this.state.visible} onHide={this.close}>
                <Modal.Header>
                    <Modal.Title>{this.props.header}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
					<React.Fragment>
						<Row>
							<Col md={12}>
								<Label htmlFor="appealReason" required>{this.props.label}</Label>
							</Col>
						</Row>
						<Row>
							<Col md={12}>
								<TextAreaBox
									name="appealReason"
									placeholder="Enter your comments here"
									maxLength={200}
									rows={4}
									required
									value={this.state.appealReason}
									onChange={this.onReasonChange} />
							</Col>
						</Row>
					</React.Fragment>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="link" onClick={this.close}>Cancel</Button>
                    <Button bsStyle="primary" onClick={this.confirm}>Add Comment & Save</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default AppealRequestPopUp;


// WEBPACK FOOTER //
// ./src/areas/shared/modals/AppealRequestPopUp/AppealRequestPopUp.js